import React from "react";
import {
  Map,
  GoogleApiWrapper,
  Marker,
  InfoWindow,
} from "../../../../../_components/c_package/google-maps-react";

// import managedWh from "./../../../../../assets/images/MapViewIcon/managed-warehouse-locationbg.svg";
import managedWh from "./../../Images/Warehouse/nonCertifiedWarehouse.png";

import managedBl from "./../../Images/Warehouse/nonCertifiedWarehouse.png";
import certified from "./../../Images/Warehouse/certifiedWarehouse.png";
import certifiedBl from "./../../Images/Warehouse/certifiedWarehouse.png";

import apmc from "./../../Images/Warehouse/apmcMandi.png";
import railway from "./../../Images/Warehouse/railwayStation.png";
import { URL_CONFIG } from "../../../../../_constants/Config/URL_CONFIG";
import Infoiconsvg from "./infoiconsvg";
import MapLegend from "./MapLegend";
import { isMobile } from "../../helperFunc";

const mapStyles = {
  width: "100%",
  height: "100%",
};

class GoogleMapView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stores: [],
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      markerObjects: [],
      latlong: "",
      whWindow: false,
      show: false,
    };

    this.onMarkerMounted = (element) => {
      if (element) {
        this.setState((prevState) => ({
          markerObjects: [...prevState.markerObjects, element.marker],
        }));
      }
    };

    this.iconSize = this.props.showInfoIcon ? 32 : 20;
  }

  componentDidMount() {
    this.setState({
      latlong: this.props.currentLatLong,
    });
  }

  componentDidUpdate(prev) {
    if (prev.currentLatLong !== this.props.currentLatLong) {
      this.setState(
        {
          latlong: this.props.currentLatLong,
        },
        () => {
          this.forceUpdate();
        }
      );
    }
  }

  setShow = (value = false) => {
    this.setState({
      show: value,
    });
  };

  displayMarkers = () => {
    let iconMarker = new window.google.maps.MarkerImage(
      managedWh,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );
    let certified_icon = new window.google.maps.MarkerImage(
      certified,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );

    let managedBls = new window.google.maps.MarkerImage(
      managedBl,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );
    let certifiedBls = new window.google.maps.MarkerImage(
      certifiedBl,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );

    return this.props.warehouses.map((store, index) => {
      if (store.warehouse_details.warehouse_lat === null) {
        return null;
      }

      let iconBG = this.state.latlong?.warehouse_slug === store?.warehouse_slug;

      let icon =
        store.warehouse_details.arya_certified_fullfiled === 2
          ? iconBG
            ? managedBls
            : iconMarker
          : iconBG
          ? certifiedBls
          : certified_icon;

      let zindexStyle = {};
      if (iconBG)
        zindexStyle = {
          zIndex: 99999,
        };

      return (
        <Marker
          ref={this.onMarkerMounted}
          icon={icon}
          key={store.id + "warehouse1"}
          id={store.warehouse_slug}
          position={{
            lat: store.warehouse_details.warehouse_lat
              ? store.warehouse_details.warehouse_lat
              : "28.651860",
            lng: store.warehouse_details.warehouse_long
              ? store.warehouse_details.warehouse_long
              : "77.316590",
          }}
          title={
            <a
              href={
                URL_CONFIG.ORIGIN_URL +
                "/warehouse/" +
                store.warehouse_slug +
                "/" +
                store.id
              }
            >
              {store.name}
            </a>
          }
          onClick={(props, marker, e) =>
            this.onMarkerClick(props, marker, e, "wh")
          }
          {...zindexStyle}
        ></Marker>
      );
    });
  };

  ApmcMarkers = () => {
    let iconMarker = new window.google.maps.MarkerImage(
      apmc,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );

    return this.props.warehouses.map((store, index) => {
      if (store.warehouse_details.apmc_lat === null) {
        return null;
      }

      return (
        <Marker
          ref={this.onMarkerMounted}
          icon={
            iconMarker
          }
          key={store.id + "apmc"}
          id={store.id + "apmc"}
          position={{
            lat: store.warehouse_details.apmc_lat
              ? store.warehouse_details.apmc_lat
              : "28.651860",
            lng: store.warehouse_details.apmc_long
              ? store.warehouse_details.apmc_long
              : "77.316590",
          }}
          title={store.warehouse_details.apmc_name}
          // title={<a href={URL_CONFIG.ORIGIN_URL+ "/warehouse/" + store.warehouse_slug}>{store.warehouse_details.apmc_name}</a>}
          onClick={this.onMarkerClick}
        ></Marker>
      );
    });
  };

  RailwayMarkers = () => {
    let iconMarker = new window.google.maps.MarkerImage(
      railway,
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      null /* anchor is bottom center of the scaled image */,
      new window.google.maps.Size(this.iconSize, this.iconSize)
    );

    return this.props.warehouses.map((store, index) => {
      if (store.warehouse_details.railway_station_lat === null) {
        return null;
      }

      return (
        <Marker
          ref={this.onMarkerMounted}
          icon={
            iconMarker
          }
          key={store.id + "rail"}
          id={store.id + "rail"}
          position={{
            lat: store.warehouse_details.railway_station_lat
              ? store.warehouse_details.railway_station_lat
              : "28.651860",
            lng: store.warehouse_details.railway_station_long
              ? store.warehouse_details.railway_station_long
              : "77.316590",
          }}
          title={store.warehouse_details.railway_station_name}
          // title={<a href={URL_CONFIG.ORIGIN_URL+"/warehouse/" + store.warehouse_slug}>{store.warehouse_details.railway_station_name}</a>}
          onClick={this.onMarkerClick}
        ></Marker>
      );
    });
  };

  onMarkerClick = (props, marker, e, wh) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      whWindow: wh ? true : false,
    });
  };

  onClose = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  render() {
    let latlong = { lat: 21.001572, lng: 81.585776 };
    let zoom = this.props.zoomIndex ? this.props.zoomIndex : 5.2;
    // let latAndlong = localStorage.getItem("latAndlng")
    let latAndlong = this.state.latlong;
    if (latAndlong?.lat) {
      latlong = latAndlong;
      zoom = 13;
    }

    return (
      <div className="mapSec">
        <MapLegend show={this.state.show} setShow={this.setShow} />
        <React.Fragment>
          <Map
            ref={(map) => (this._map = map)}
            google={this.props.google}
            zoom={zoom}
            style={mapStyles}
            // initialCenter={latlong}
            center={latlong}
          >
            {this.ApmcMarkers()}
            {this.RailwayMarkers()}
            {this.displayMarkers()}

            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
              className="MapInfoIcon"
              class="MapInfoIcon"
            >
              <div
                onClick={() => {
                  this.state.whWindow &&
                    this.props.history.push(
                      "/warehouse/" +
                        this.state.selectedPlace.warehouse_slug +
                        "/" +
                        this.state.selectedPlace.id
                    );
                }}
              >
                <div>{this.state.selectedPlace.title}</div>
              </div>
            </InfoWindow>
            {/* {this.props.showInfoIcon && ( */}
            {isMobile && (
              <div
                className={`info-icon-css ${
                  !this.props.showInfoIcon ? "infoIconBottom" : ""
                }`}
                onClick={() => this.setShow(true)}
              >
                <Infoiconsvg />
              </div>
            )}
            {/* )} */}
          </Map>
        </React.Fragment>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: URL_CONFIG.GOOGLE_API_KEY,
  //libraries: ["places"]
})(GoogleMapView);
